import * as React from "react";
import { useState } from "react";
import SettingAppointmentsNotification, {
  SettingAppointmentsNotificationModel,
} from "./settings/SettingAppointmentsNotification";
import ReportNotificationSettingPanel, {
  ReportNotificationSetting,
} from "./settings/ReportNotificationSettingPanel";
import HeaderBar from "./commons/components/HeaderBar";
import { AvailableEntitiesSettings } from "./commons/model/EntitySettings";
import LoadingSpinner from "./flow/utils/LoadingSpinner";
import { createRoot } from "react-dom/client";

interface SettingsNotificationProps {
  entities: AvailableEntitiesSettings;
  appointmentsNotificationProps?: SettingAppointmentsNotificationModel;
  reportNotificationSetting?: ReportNotificationSetting;
}

export default function SettingsNotification({
  entities,
  appointmentsNotificationProps,
  reportNotificationSetting,
}: SettingsNotificationProps) {
  const [errorMessage, setErrorMessage] = useState<string>();

  const [loading, setLoading] = useState(false);

  const reportNotification = () => {
    return (
      reportNotificationSetting && (
        <div className="panel with-shadow">
          <div className="setting-title">
            {i18n["Page.Settings.Customisation.Notification.Report.Title"]}
          </div>
          <div>
            <ReportNotificationSettingPanel
              {...reportNotificationSetting}
              displayError={(_errorMessage) => setErrorMessage(_errorMessage)}
            />
          </div>
        </div>
      )
    );
  };

  const appointmentsNotification = () => {
    return (
      appointmentsNotificationProps &&
      appointmentsNotificationProps.displayAppointmentSettings && (
        <div className="panel with-shadow">
          <div className="setting-title">{i18n["Page.Settings.Customisation.Appointments"]}</div>
          <div>
            <SettingAppointmentsNotification
              {...appointmentsNotificationProps}
              displayError={(_errorMessage) => setErrorMessage(_errorMessage)}
            />
          </div>
        </div>
      )
    );
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="settings-customisation v-flex no-wrap full-height">
      <HeaderBar
        title={i18n["Page.Settings.Notification.Title"]}
        entities={entities}
        onChange={() => {
          setLoading(true);
        }}
      />
      <div className="container">
        {errorMessage && <div className="message danger">{errorMessage}</div>}
        {reportNotification()}
        {appointmentsNotification()}
      </div>
    </div>
  );
}

SettingsNotification.loadComponent = (elementId: string, props: SettingsNotificationProps) => {
  const container = document.getElementById(elementId);
  const root = createRoot(container!);
  root.render(<SettingsNotification {...props} />);
};
